"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var waitForEl = function waitForEl(selector, callback) {
  if (document.querySelector(selector)) {
    callback();
  } else {
    setTimeout(function () {
      waitForEl(selector, callback);
    }, 100);
  }
};
/*
 * Woolman Common JS
 */

// Initialize window.Woolman object
if (typeof window.Woolman == 'undefined') {
  window.Woolman = {};
}
Woolman.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

// -------
// Load components / libraries
Woolman.init = function () {
  Woolman.ModalsAndDrawers.init();
  Woolman.Header.init();
  Woolman.DetailsAccordions.init();

  // Attach theme editor listeners
  if (!Shopify || !Shopify.designMode) return;
  var lastSelection = {
    sectionId: undefined,
    blockId: undefined
  };

  // Load is called when something is changed within section settings
  document.addEventListener('shopify:section:load', function (evt) {
    var sectionId = 'shopify-section-' + evt.detail.sectionId;
    if (sectionId === Woolman.Header.cache.section.id) {
      Woolman.ModalsAndDrawers.init();
      Woolman.Header.init();
    }
    if (document.querySelector("[data-modal][data-section-id=\"".concat(evt.detail.sectionId, "\"]"))) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector("[data-modal][data-section-id=\"".concat(evt.detail.sectionId, "\"]")).id);
    }
    console.log('shopify:section:load sectionId', evt.detail.sectionId);
    console.log('lastSelection', lastSelection);
  });
  document.addEventListener('shopify:block:select', function (evt) {
    var sectionId = 'shopify-section-' + evt.detail.sectionId;
    var blocks = document.getElementById(sectionId).querySelectorAll('[data-shopify-editor-block]');
    var selectedBlock = _toConsumableArray(blocks).find(function (x) {
      return JSON.parse(x.dataset.shopifyEditorBlock).id === evt.detail.blockId;
    });
    if (sectionId === Woolman.Header.cache.section.id) {
      if (selectedBlock) {
        // Make sure menu is open
        Woolman.Header.cache.openButton.click();

        // Select menu item
        var accordion = selectedBlock.closest('[data-accordion-item]').querySelector('input');
        var label = selectedBlock.closest('[data-accordion-item]').querySelector('label');
        if (!accordion.checked) label.click();
      }
    } else if (sectionId.includes('modal') && document.getElementById(sectionId).querySelector('[data-modal]')) {
      if (selectedBlock) {
        Woolman.ModalsAndDrawers.showModalOrDrawer(document.getElementById(sectionId).querySelector('[data-modal]').id);
      }
    }
    lastSelection.sectionId = evt.detail.sectionId;
    lastSelection.blockId = evt.detail.blockId;
    console.log('shopify:block:select', evt.detail.sectionId, evt.detail.blockId);
    console.log('lastSelection', lastSelection);
  });
  document.addEventListener('shopify:section:unload', function (evt) {
    console.log('shopify:section:unload sectionId', evt.detail.sectionId);
  });
  document.addEventListener('shopify:section:select', function (evt) {
    console.log('shopify:section:select', evt.detail.sectionId);
    lastSelection = {
      sectionId: evt.detail.sectionId,
      blockId: evt.detail.blockId
    };
    if (evt.detail.sectionId.includes('modal') && document.querySelector("[data-modal][data-section-id=\"".concat(evt.detail.sectionId, "\"]"))) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector("[data-modal][data-section-id=\"".concat(evt.detail.sectionId, "\"]")).id);
    }
    console.log('lastSelection', lastSelection);
  });
  document.addEventListener('shopify:section:deselect', function (evt) {
    console.log('shopify:section:deselect', evt.detail.sectionId);
    lastSelection = {
      sectionId: undefined,
      blockId: undefined
    };
    if (evt.detail.sectionId.includes('modal') && document.querySelector("[data-modal][data-section-id=\"".concat(evt.detail.sectionId, "\"]"))) {
      Woolman.ModalsAndDrawers.closeModalOrDrawer(document.querySelector("[data-modal][data-section-id=\"".concat(evt.detail.sectionId, "\"]")).id);
    }
    console.log('lastSelection', lastSelection);
  });
};

// -------
// Woolman Common JS - Utility library
Woolman.Utils = {
  debugMode: true,
  focusTraps: {},
  checkCanFocusTrap: function checkCanFocusTrap(trapContainers) {
    var results = trapContainers.map(function (trapContainer) {
      return new Promise(function (resolve) {
        var interval = setInterval(function () {
          if (getComputedStyle(trapContainer).visibility !== 'hidden') {
            resolve();
            clearInterval(interval);
          }
        }, 5);
      });
    });
    // Return a promise that resolves when all the trap containers are able to receive focus
    return Promise.all(results);
  },
  onFocusTrapDeactivate: function onFocusTrapDeactivate(targetElement) {
    targetElement.classList.remove('focus-trap');
    document.body.classList.remove('focus-being-trapped');
  },
  onFocusTrapActivate: function onFocusTrapActivate(targetElement) {
    targetElement.classList.add('focus-trap');
    document.body.classList.add('focus-being-trapped');
  },
  clearFocusTrap: function clearFocusTrap(cacheKey) {
    if (Woolman.Utils.focusTraps[cacheKey]) {
      Woolman.Utils.focusTraps[cacheKey].deactivate();
      Woolman.Utils.focusTraps[cacheKey] = undefined;
    }
  },
  prepareQueryParams: function prepareQueryParams() {
    Shopify.queryParams = Shopify.queryParams || {};

    // Preserve existing query parameters
    if (location.search.length) {
      var params = location.search.substr(1).split('&');
      for (var i = 0; i < params.length; i++) {
        var keyValue = params[i].split('=');
        if (keyValue.length) {
          Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
        }
      }
    }
    return Shopify.queryParams;
  },
  formatMoney: function formatMoney(cents, format) {
    var _window, _window$Shopify, _window$Shopify$curre;
    var default_money_format = theme.settings.moneyFormat || '€{{amount}}';
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    if ((_window = window) !== null && _window !== void 0 && (_window$Shopify = _window.Shopify) !== null && _window$Shopify !== void 0 && (_window$Shopify$curre = _window$Shopify.currency) !== null && _window$Shopify$curre !== void 0 && _window$Shopify$curre.rate) {
      cents = cents * parseFloat(window.Shopify.currency.rate || 1.0);
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || default_money_format;
    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
};

// -------
// Woolman Common JS - Header component
Woolman.Header = {
  selectors: {
    header: 'MainHeader',
    cartBlip: '.cart-blip'
  },
  cache: {
    header: undefined,
    cartBlip: undefined,
    section: undefined,
    openButton: undefined
  },
  focusTraps: {},
  init: function init() {
    this.cache.header = document.getElementById(this.selectors.header);
    this.cache.cartBlip = this.cache.header.querySelector(this.selectors.cartBlip);
    this.cache.section = this.cache.header.closest('.shopify-section');
    this.cache.openButton = this.cache.header.querySelector('[href="#drawer-menu"]');

    // Update cart blip when product is added to cart.
    document.addEventListener('ajaxProduct:added', this.updateCartBlip.bind(this));
    document.addEventListener('cart:update', this.updateCartBlip.bind(this));
    if (this.cache.header.dataset.stickyBehavior === 'none') return;
    this.initStickyBehavior(this.cache.header.dataset.stickyBehavior);
  },
  initStickyBehavior: function initStickyBehavior(behaviorType) {
    var stickyConfig = {
      headerHeight: this.cache.header.clientHeight,
      behavior: behaviorType
    };
    document.documentElement.classList.add('sticky-header-initialized', "sticky-header-".concat(behaviorType));
    document.documentElement.style.setProperty('--sticky-header-margin-top', "".concat(stickyConfig.headerHeight, "px"));
    if (behaviorType === 'scroll' || behaviorType === 'fixed') {
      // Show on scroll fixed header
      var prevScroll = window.scrollY || document.documentElement.scrollTop;
      var curScroll;
      var direction = 0;
      var prevDirection = 0;

      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */
      var elementTopOffset = 0;
      if (document.querySelector(".boost-sd-container .boost-sd__toolbar-wrapper")) {
        elementTopOffset = document.querySelector(".boost-sd-container .boost-sd__toolbar-wrapper").getBoundingClientRect().top;
        if (window.innerWidth <= 768) {
          elementTopOffset = parseFloat(elementTopOffset) - 650;
        } else {
          elementTopOffset = parseFloat(elementTopOffset) - 100;
        }
      }
      var toggleStickyHeader = function toggleStickyHeader(direction, curScroll) {
        if (direction === 1 || curScroll < stickyConfig.headerHeight) {
          document.documentElement.classList.remove('sticky-header-hide');
          document.documentElement.classList.remove('sticky-collection-filter-hide');
          if (document.querySelector(".boost-sd-container .boost-sd__toolbar-wrapper")) {
            if (curScroll > elementTopOffset) {
              document.documentElement.classList.add('sticky-collection-filter-hide');
            }
          }
        } else if (direction === 2 && curScroll > stickyConfig.headerHeight) {
          document.documentElement.classList.add('sticky-header-hide');
          if (document.querySelector(".boost-sd-container .boost-sd__toolbar-wrapper")) {
            if (curScroll > elementTopOffset) {
              document.documentElement.classList.add('sticky-collection-filter-hide');
            }
          }
        }
        prevDirection = direction;
      };
      window.addEventListener('scroll', throttle(function () {
        curScroll = window.scrollY || document.documentElement.scrollTop;
        if (curScroll >= 300) {
          document.documentElement.classList.add('sticky-header-show');
          if (document.querySelector(".boost-sd-container .boost-sd__toolbar-wrapper")) {
            if (curScroll > elementTopOffset) {
              document.documentElement.classList.add('sticky-collection-filter-show');
            }
          }
        } else {
          document.documentElement.classList.remove('sticky-header-show');
          document.documentElement.classList.remove('sticky-collection-filter-show');
        }
        if (curScroll > prevScroll) {
          direction = 2; // user scrolling down
        } else {
          direction = 1; // user scrolling up
        }
        if (direction !== prevDirection && behaviorType === 'scroll') {
          toggleStickyHeader(direction, curScroll);
        }
        prevScroll = curScroll;
      }, 50));
      setInterval(function () {
        if (direction === 2 && behaviorType === 'scroll' && curScroll >= 900) {
          toggleStickyHeader(direction, curScroll);
        }
        if (window.scrollY === 0) {
          document.documentElement.classList.remove('sticky-header-show', 'sticky-header-hide', 'sticky-collection-filter-show', 'sticky-collection-filter-hide');
        }
      }, 200);
    }
  },
  updateCartBlip: function updateCartBlip(e) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var cart, total_in_notification;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = e.detail && e.detail.cart && e.detail.cart.item_count;
            if (_context2.t0) {
              _context2.next = 5;
              break;
            }
            _context2.next = 4;
            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              var res, cart;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return fetch('/cart.json');
                  case 2:
                    res = _context.sent;
                    _context.next = 5;
                    return res.json();
                  case 5:
                    cart = _context.sent;
                    return _context.abrupt("return", cart);
                  case 7:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }))();
          case 4:
            _context2.t0 = _context2.sent;
          case 5:
            cart = _context2.t0;
            _this.cache.cartBlip.textContent = cart.item_count || 0;
            if (cart && cart.item_count == 0) {
              _this.cache.cartBlip.setAttribute('hidden', true);
              _this.cache.cartBlip.closest('.header-item__link').classList.remove('has-blip-visible');
            } else {
              _this.cache.cartBlip.removeAttribute('hidden');
              _this.cache.cartBlip.closest('.header-item__link').classList.add('has-blip-visible');
            }

            // Update notification cart amount at the same time (if present)
            total_in_notification = document.querySelector('#cart-notification-link .cart-total');
            if (total_in_notification) {
              total_in_notification.textContent = cart.item_count;
            }
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};

// -------
// Woolman Common JS - Modals & drawers library
Woolman.ModalsAndDrawers = {
  settings: {
    selectors: {
      modalLink: 'a[href*="modal"]:not(.quick-buy_link)',
      drawerLink: 'a[href*="drawer"]'
    }
  },
  focusTraps: {},
  init: function init() {
    var _this2 = this;
    // Init open event listeners
    document.querySelectorAll(this.settings.selectors.modalLink).forEach(function (modalLink) {
      modalLink.addEventListener('click', function (event) {
        event.preventDefault();
        var targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        var pageId = event.currentTarget.getAttribute('href').substring(1).split('?page=')[1];
        _this2.showModalOrDrawer(targetId, parseInt(pageId));
      });
    });
    document.querySelectorAll(this.settings.selectors.drawerLink).forEach(function (drawerLink) {
      drawerLink.addEventListener('click', function (event) {
        event.preventDefault();
        var targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        var drawerId = event.currentTarget.getAttribute('id');
        var reviewsContainer = document.querySelector('.reviews_all_container');
        if (targetId == "drawer-search") {
          var featured = document.querySelector("#drawer-search .drawer-content input.search__input");
          setTimeout(function () {
            featured.focus();
          }, 100);
        }
        if (window.innerWidth < 1024) {
          if (targetId == "drawer-menu") {
            if (document.body.classList.contains("drawer-menu-open")) {
              document.querySelector(".drawer.drawer-menu a.close").click();
            } else {
            var bodyClass = targetId + "-open";
            document.body.classList.add(bodyClass);
            var pageId = event.currentTarget.getAttribute('href').substring(1).split('?page=')[1];
            _this2.showModalOrDrawer(targetId, parseInt(pageId));
            }
          } else if (drawerId == "drawer-klaviyo-review" && !reviewsContainer) {
          } else if (drawerId == "drawer-klaviyo-review" && reviewsContainer) {
            var bodyClass = targetId + "-open";
            document.body.classList.add(bodyClass);
            var _pageId = event.currentTarget.getAttribute('href').substring(1).split('?page=')[1];
            _this2.showModalOrDrawer(targetId, parseInt(_pageId));
          } else if (drawerId == "" && !reviewsContainer) {
            var bodyClass = targetId + "-open";
            document.body.classList.add(bodyClass);
            var _pageId = event.currentTarget.getAttribute('href').substring(1).split('?page=')[1];
            _this2.showModalOrDrawer(targetId, parseInt(_pageId));
          } else {
          var bodyClass = targetId + "-open";
          document.body.classList.add(bodyClass);
          var _pageId = event.currentTarget.getAttribute('href').substring(1).split('?page=')[1];
          _this2.showModalOrDrawer(targetId, parseInt(_pageId));
          }
        } else if (drawerId == "drawer-klaviyo-review" && !reviewsContainer) {
        } else if (drawerId == "drawer-klaviyo-review" && reviewsContainer) {
          var bodyClass = targetId + "-open";
          document.body.classList.add(bodyClass);
          var _pageId2 = event.currentTarget.getAttribute('href').substring(1).split('?page=')[1];
          _this2.showModalOrDrawer(targetId, parseInt(_pageId2));
        } else if (drawerId == "" && !reviewsContainer) {
          var bodyClass = targetId + "-open";
          document.body.classList.add(bodyClass);
          var _pageId2 = event.currentTarget.getAttribute('href').substring(1).split('?page=')[1];
          _this2.showModalOrDrawer(targetId, parseInt(_pageId2));
        } else {
          var bodyClass = targetId + "-open";
          document.body.classList.add(bodyClass);
          var _pageId2 = event.currentTarget.getAttribute('href').substring(1).split('?page=')[1];
          _this2.showModalOrDrawer(targetId, parseInt(_pageId2));
        }
      });
    });

    // Init close event listeners
    var closeBtns = document.querySelectorAll('[data-close]');
    if (closeBtns) {
      closeBtns.forEach(function (closeBtn) {
        closeBtn.addEventListener('click', _this2.closeModalOrDrawerOrDrawerFromEvent.bind(_this2));
      });
    }
    var overlays = document.querySelectorAll('[data-overlay]');
    if (overlays) {
      overlays.forEach(function (overlay) {
        overlay.addEventListener('click', _this2.closeModalOrDrawerOrDrawerFromEvent.bind(_this2));
      });
    }
  },
  /**
   *
   * @param {string} targetId - ID of modal or drawer element, e.g. modal-geo, drawer-menu
   * @param {int} pageId - ID of page to load in modal or drawer, e.g. 1, 2, 3 (for multi-modal)
   * Traps focus to modal and disables body scrolling.
   * Focus trap utilizes focus-trap library: https://github.com/focus-trap/focus-trap
   */
  showModalOrDrawer: function showModalOrDrawer(targetId, pageId) {
    var targetElement = document.getElementById(targetId);
    if (!targetElement && Woolman.Utils.debugMode) {
      console.warn('No modal/drawer element specified');
    }
    if (!targetElement) {
      return;
    }
    if (targetElement.classList.contains('is-open')) return;
    var bodyClass = targetId + "-open";
    document.body.classList.add(bodyClass);
    targetElement.classList.add('initialized', 'is-open');
    document.body.classList.add('overflow-hidden');
    var isMultiModal = targetElement.nodeName === 'MODAL-GRIDY-SLIDER-PARENT';
    if(targetId == "drawer-cart") {
      document.documentElement.classList.add('sticky-header-scroll');
      document.documentElement.classList.add('sticky-header-show');
      document.documentElement.classList.remove('sticky-header-hide');
    }
    if (targetId == "modal-newsletter") {
      if (!Woolman.Utils.focusTraps[targetId]) {
        const trapTarget = targetElement.querySelector('[data-contents-wrapper]') || targetElement.querySelector('[data-contents]') || targetElement;
        Woolman.Utils.focusTraps[targetId] = focusTrap.createFocusTrap(trapTarget, {
          clickOutsideDeactivates: isMultiModal ? false : true,
          allowOutsideClick: isMultiModal ? true : false,
          escapeDeactivates: true,
          // Called before focus is sent
          onActivate: () => {
            Woolman.Utils.onFocusTrapActivate(targetElement);
            setTimeout(() => {
              // check targetElement node name to determine if it's a modal or drawer
              if (pageId && isMultiModal) {
                const gridySlider = targetElement.querySelector('gridy-slider');
                gridySlider.scrollToSlide(pageId - 1);
              }
            }, 250);
            bodyScrollLock.disableBodyScroll(targetElement);
          },
          // There is a delay between when the class is applied
          // and when the element is focusable
          checkCanFocusTrap: Woolman.Utils.checkCanFocusTrap,
          // Called after focus is deactivated
          onDeactivate: () => {
            bodyScrollLock.enableBodyScroll(targetElement);
            Woolman.Utils.onFocusTrapDeactivate(targetElement);
          }
        });
      }
      Woolman.Utils.focusTraps[targetId].activate();
    }
  },
  /**
   *
   * @param {string} targetId - ID of target element, e.g. modal-geo, drawer-menu
   * Removes trapped focus when modal is closed by e.g. using the close button.
   */
  closeModalOrDrawer: function closeModalOrDrawer(targetId) {
    if (Woolman.Utils.focusTraps[targetId]) {
      Woolman.Utils.focusTraps[targetId].deactivate();
      Woolman.Utils.focusTraps[targetId] = undefined;
    }
  },
  closeModalOrDrawerOrDrawerFromEvent: function closeModalOrDrawerOrDrawerFromEvent(event) {
    event.preventDefault();
    var parentElement = event.currentTarget.closest('[data-parent]');
    var targetId = parentElement.getAttribute('id');
    var bodyClass = targetId + "-open";
    document.body.classList.remove('overflow-hidden');    
    // Remove the class from body and parentElement after 2 seconds
    setTimeout(function() {
        document.body.classList.remove(bodyClass);
        parentElement.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
    }, 100);
    Woolman.ModalsAndDrawers.closeModalOrDrawer(targetId);
  }
};

/**
 * Animated details element
 */
var Accordion = /*#__PURE__*/function () {
  function Accordion(el) {
    var _this3 = this;
    _classCallCheck(this, Accordion);
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.content');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', function (e) {
      return _this3.onClick(e);
    });
  }
  _createClass(Accordion, [{
    key: "onClick",
    value: function onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }
  }, {
    key: "shrink",
    value: function shrink() {
      var _this4 = this;
      this.isClosing = true;
      var startHeight = "".concat(this.el.offsetHeight, "px");
      var endHeight = "".concat(this.summary.offsetHeight, "px");
      if (this.animation) {
        this.animation.cancel();
      }
      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-in-out'
      });
      this.animation.onfinish = function () {
        return _this4.onAnimationFinish(false);
      };
      this.animation.oncancel = function () {
        return _this4.isClosing = false;
      };
    }
  }, {
    key: "open",
    value: function open() {
      var _this5 = this;
      this.el.style.height = "".concat(this.el.offsetHeight, "px");
      this.el.open = true;
      window.requestAnimationFrame(function () {
        return _this5.expand();
      });
    }
  }, {
    key: "expand",
    value: function expand() {
      var _this6 = this;
      this.isExpanding = true;
      var startHeight = "".concat(this.el.offsetHeight, "px");
      var endHeight = "".concat(this.summary.offsetHeight + this.content.offsetHeight, "px");
      if (this.animation) {
        this.animation.cancel();
      }
      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = function () {
        return _this6.onAnimationFinish(true);
      };
      this.animation.oncancel = function () {
        return _this6.isExpanding = false;
      };
    }
  }, {
    key: "onAnimationFinish",
    value: function onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
    }
  }]);
  return Accordion;
}();
;
Woolman.DetailsAccordions = {
  init: function init() {
    document.querySelectorAll('details').forEach(function (el) {
      new Accordion(el);
    });
  }
};
Woolman.init();
function customNewsletterModalClose(e) {
  if (!e.keyCode || e.keyCode === 27) {
    document.querySelector("#modal-newsletter .modal-close").click();
  }
}
document.addEventListener('keydown', customNewsletterModalClose);
function customGeoIPSetCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function customGeoIPGetCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function customGeoIPEraseCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
if (document.querySelector("#modal-newsletter")) {
  var getCustomNewsletterCookie = customGeoIPGetCookie('custom-newsletter');
  var getTestMode = document.querySelector("#modal-newsletter .custom-newsletter-form").getAttribute("data-test-mode");
  if (Shopify.designMode) {
    if (typeof getTestMode != "undefined" && getTestMode != null && getTestMode != "") {
      if (getTestMode == "true") {
        Woolman.ModalsAndDrawers.showModalOrDrawer("modal-newsletter");
        setTimeout(function () {
          document.querySelector("#modal-newsletter .custom-newsletter-email").focus();
        }, 300);
      }
    }
  } else {
    if (typeof getCustomNewsletterCookie != "undefined" && getCustomNewsletterCookie != null && getCustomNewsletterCookie != "") {
      if (typeof getTestMode != "undefined" && getTestMode != null && getTestMode != "") {
        if (getTestMode == "true") {
          Woolman.ModalsAndDrawers.showModalOrDrawer("modal-newsletter");
          setTimeout(function () {
            document.querySelector("#modal-newsletter .custom-newsletter-email").focus();
          }, 300);
        }
      }
    } else {
      var getDelay = document.querySelector("#modal-newsletter .custom-newsletter-form").getAttribute("data-delay");
      getDelay = parseInt(getDelay);
      setTimeout(function () {
        Woolman.ModalsAndDrawers.showModalOrDrawer("modal-newsletter");
        setTimeout(function () {
          document.querySelector("#modal-newsletter .custom-newsletter-email").focus();
        }, 100);
      }, getDelay);
    }
  }
  document.querySelector("#modal-newsletter .modal-close").addEventListener('click', function (event) {
    event.preventDefault();
    const parentElement = event.currentTarget.closest('[data-parent]');
    var getFrequency = document.querySelector("#modal-newsletter .custom-newsletter-form").getAttribute("data-frequency");
    getFrequency = parseInt(getFrequency);
    const targetId = parentElement.getAttribute('id');
    var bodyClass = targetId + "-open";
    customGeoIPSetCookie('custom-newsletter', 'yes', getFrequency);
    document.body.classList.remove(bodyClass);
    parentElement.classList.remove('is-open');
    Woolman.ModalsAndDrawers.closeModalOrDrawer(targetId);
  });
  document.querySelector("#modal-newsletter .page-overlay").addEventListener('click', function (event) {
    event.preventDefault();
    const parentElement = event.currentTarget.closest('[data-parent]');
    var getFrequency = document.querySelector("#modal-newsletter .custom-newsletter-form").getAttribute("data-frequency");
    getFrequency = parseInt(getFrequency);
    const targetId = parentElement.getAttribute('id');
    var bodyClass = targetId + "-open";
    customGeoIPSetCookie('custom-newsletter', 'yes', getFrequency);
    document.body.classList.remove(bodyClass);
    parentElement.classList.remove('is-open');
    Woolman.ModalsAndDrawers.closeModalOrDrawer(targetId);
  });
}
var getAllNewsletter = document.querySelectorAll(".custom-newsletter-form");
if (getAllNewsletter) {
  document.querySelectorAll(".newsletter-popup-form-outer-wrapper").forEach(function (element, optionKey) {
    var newsLetterForm = element.querySelector(".custom-newsletter-form");
    newsLetterForm.addEventListener("submit", function (event) {
      event.preventDefault();
      var getFrequency = event.target.getAttribute("data-frequency");
      if (typeof getFrequency != "undefined" && getFrequency != null && getFrequency != "") {
        getFrequency = parseInt(getFrequency);
      }
      var newsletterEmail = element.querySelector(".custom-newsletter-email").value;
      var content = _toConsumableArray(element.querySelectorAll('[name=content]')).filter(function (x) {
        return x.checked;
      }).map(function (x) {
        return x.value;
      });
      var language = _toConsumableArray(element.querySelectorAll('.custom-newsletter-form-language-input')).filter(function (x) {
        return x.checked;
      }).map(function (x) {
        return x.value;
      });
      language = language.toString();
      var CustomSubscribeData = {
        "a": "Xtgk3i",
        "g": "QVZGb3",
        // replace LIST_ID with id of list to be subscribed
        "email": newsletterEmail,
        // pass in additional fields, each additional field
        // must be included in the $fields string separated by commas
        "$fields": "$source, Newsletter Language",
        "$source": "Shopify",
        "Newsletter Language": language
      };
      if (typeof content != "undefined" && content != null && content != "") {
        CustomSubscribeData = {
          "a": "Xtgk3i",
          "g": "QVZGb3",
          // replace LIST_ID with id of list to be subscribed
          "email": newsletterEmail,
          // pass in additional fields, each additional field
          // must be included in the $fields string separated by commas
          "$fields": "$source, Newsletter Language, Content",
          "$source": "Shopify",
          "Newsletter Language": language,
          "Content": JSON.stringify(content)
        };
      }
      element.querySelector(".custom-newsletter-form-submit-field button").disabled = true;
      $.ajax({
        "async": true,
        "crossDomain": true,
        "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        "method": "POST",
        "headers": {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache"
        },
        "data": CustomSubscribeData,
        success: function success(data) {
          if (data.success == false) {
            element.querySelector(".custom-newsletter-form-submit-field button").disabled = false;
            alert(data.errors[0]);
          } else {
            element.querySelector(".custom-newsletter-form-submit-field button").disabled = false;
            if (typeof getFrequency != "undefined" && getFrequency != null && getFrequency != "") {
              customGeoIPSetCookie('custom-newsletter', 'yes', getFrequency);
            }
            element.querySelector(".newsletter-popup-form").style.display = "none";
            element.querySelector(".newsletter-popup-form-success-message").style.display = "block";
          }
        },
        error: function error(data) {
          element.querySelector(".custom-newsletter-form-submit-field button").disabled = false;
          alert(data.errors[0]);
        }
      });
    });
  });
}
function debounce(fn, wait) {
  var _this7 = this;
  var t;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(t);
    t = setTimeout(function () {
      return fn.apply(_this7, args);
    }, wait);
  };
}
function throttle(fn, wait) {
  var _this8 = this;
  var t = false;
  return function () {
    if (!t) {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      fn.apply(_this8, args);
      t = true;
      setTimeout(function () {
        return t = false;
      }, wait);
    }
  };
}

/**
 * Allow us to trigger something when window is actually resized.
 */
var woolman_window_size = window.innerWidth;
window.addEventListener('resize', debounce(function () {
  if (window.innerWidth == woolman_window_size) {
    return;
  }
  woolman_window_size = window.innerWidth;
  document.dispatchEvent(new CustomEvent('woolman:resize'));
}), 250);
var LocalizationForm = /*#__PURE__*/function (_HTMLElement) {
  _inherits(LocalizationForm, _HTMLElement);
  var _super = _createSuper(LocalizationForm);
  function LocalizationForm() {
    var _this9;
    _classCallCheck(this, LocalizationForm);
    _this9 = _super.call(this);
    _this9.elements = {
      input: _this9.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: _this9.querySelector('button'),
      panel: _this9.querySelector('.disclosure__list-wrapper')
    };
    if (_this9.elements.button) {
      _this9.elements.button.addEventListener('click', _this9.openSelector.bind(_assertThisInitialized(_this9)));
      _this9.elements.button.addEventListener('focusout', _this9.closeSelector.bind(_assertThisInitialized(_this9)));
      _this9.addEventListener('keyup', _this9.onContainerKeyUp.bind(_assertThisInitialized(_this9)));
    }
    _this9.querySelectorAll('a').forEach(function (item) {
      return item.addEventListener('click', _this9.onItemClick.bind(_assertThisInitialized(_this9)));
    });
    return _this9;
  }
  _createClass(LocalizationForm, [{
    key: "hidePanel",
    value: function hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
  }, {
    key: "onContainerKeyUp",
    value: function onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }
  }, {
    key: "onItemClick",
    value: function onItemClick(event) {
      event.preventDefault();
      var form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  }, {
    key: "openSelector",
    value: function openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
  }, {
    key: "closeSelector",
    value: function closeSelector(event) {
      var shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }]);
  return LocalizationForm;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('localization-form', LocalizationForm);

// Custom element that enhances HTML Video Element functionality.
// Usage: <video is="superpowered-video">
var SuperPoweredVideo = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(SuperPoweredVideo, _HTMLElement2);
  var _super2 = _createSuper(SuperPoweredVideo);
  function SuperPoweredVideo() {
    var _this10;
    _classCallCheck(this, SuperPoweredVideo);
    _this10 = _super2.call(this);
    _this10.video = _this10.querySelector('video') || _this10.querySelector('iframe');
    _this10.container = _this10.closest('.video-container') || null;
    if (_this10.container) _this10.attachClickListener(_this10.closest('.video-container'));

    // check if video is iframe and has a src and that src is youtube
    if (_this10.video.nodeName === 'IFRAME' && _this10.video.src && _this10.video.src.includes('youtube') && !_this10.container) {
      _this10.video.addEventListener('load', _this10.onVideoLoad.bind(_assertThisInitialized(_this10)));
    }

    // When video is out of viewport pause it. This is to prevent videos from playing in the background.
    // If video is in viewport play it.
    // Use: Intersection Observer API
    var autoplay = _this10.dataset.autoplay || false;
    if (!autoplay || _this10.container) return _possibleConstructorReturn(_this10);
    var videoType = _this10.video.nodeName === 'VIDEO' ? 'video' : 'iframe';
    var videoHost = _this10.video.nodeName === 'VIDEO' ? 'shopify' : _this10.video.src.includes('youtube') ? 'youtube' : 'vimeo';
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (videoType == 'video') {
            _this10.video.play();
          } else if (videoHost == 'youtube') {
            _this10.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          } else if (videoHost == 'vimeo') {
            _this10.video.contentWindow.postMessage('{"method":"play"}', '*');
          }
        } else {
          if (videoType == 'video') {
            _this10.video.pause();
          } else if (videoHost == 'youtube') {
            _this10.video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (videoHost == 'vimeo') {
            _this10.video.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }
      });
    }, {
      threshold: 0.5
    });
    observer.observe(_this10.video);
    return _this10;
  }
  _createClass(SuperPoweredVideo, [{
    key: "attachClickListener",
    value: function attachClickListener(videoContainer) {
      var _this11 = this;
      if (!videoContainer) return;
      videoContainer.addEventListener('click', function (e) {
        if (_this11.video.paused) {
          _this11.video.play();
        } else {
          _this11.video.pause();
        }
      });
      this.video.onplay = function () {
        videoContainer.querySelector('button').hidden = true;
      };
      this.video.onpause = function () {
        videoContainer.querySelector('button').hidden = false;
      };
    }
  }, {
    key: "onVideoLoad",
    value: function onVideoLoad() {
      // force youtube to play on mobile
      this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  }]);
  return SuperPoweredVideo;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('superpowered-video', SuperPoweredVideo);

// Gridy Slider - a custom Woolman built slider.
// Usage: <gridy-slider>
var GridySlider = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(GridySlider, _HTMLElement3);
  var _super3 = _createSuper(GridySlider);
  function GridySlider() {
    var _this12;
    _classCallCheck(this, GridySlider);
    _this12 = _super3.call(this);
    _this12.track = _this12.querySelector('.gridy-track');
    _this12.slides = _this12.querySelectorAll('.gridy-track > *');
    var child_count = _this12.track.childElementCount;
    var data_ipr_desktop = parseInt(_this12.dataset.iprDesktop, 10) || 1;
    var data_ipr_tablet = parseInt(_this12.dataset.iprTablet, 10) || data_ipr_desktop;
    var data_ipr_mobile = parseInt(_this12.dataset.iprMobile, 10) || 1;
    var data_init_scroll_to = _this12.dataset.initScrollTo;
    var data_autoplay = _this12.dataset.autoplay != undefined ? JSON.parse(_this12.dataset.autoplay) : false;
    var data_autoplay_delay = parseInt(_this12.dataset.autoplayDelay, 10) || 5000;
    var data_is_thumbnails_slider = _this12.dataset.thumbnailsFor != undefined ? true : false;
    var data_indicator = _this12.dataset.indicator != undefined ? JSON.parse(_this12.dataset.indicator) : false;
    var thumbnail_slider = document.getElementById("thumbnail-".concat(_this12.id));
    _this12.config = {
      slide_count: child_count,
      current_slide: 0,
      active_slide_offset: 0,
      // used for thubnails slider

      ipr_desktop: data_ipr_desktop,
      ipr_tablet: data_ipr_tablet,
      ipr_mobile: data_ipr_mobile,
      breakpoint_tablet: 768,
      breakpoint_desktop: 1024,
      arrows: true,
      autoplay: data_autoplay || false,
      autoplay_delay: data_autoplay_delay,
      // in ms
      timer: null,
      // thumbnails related
      is_thumbnails_slider: data_is_thumbnails_slider,
      thumbnails_for: undefined,
      thumbnail_slider: thumbnail_slider,
      indicator: data_indicator
    };

    // SCROLL ON INIT (with variant URL)
    if (data_init_scroll_to != undefined) {
      _this12.scrollToSlideByID(data_init_scroll_to);
    }

    // ARROWS INIT
    if (_this12.config.arrows) {
      _this12.buttons = _this12.querySelectorAll('[data-gridy-arrow]');
      _this12.buttons.forEach(function (arrowButton) {
        arrowButton.addEventListener('click', _this12.onArrowClick.bind(_assertThisInitialized(_this12)));
      });
    }

    // AUTOPLAY INIT
    if (_this12.config.autoplay) {
      _this12.autoplayGridy();

      // Always pause on hover
      _this12.addEventListener('mouseenter', _this12.clearAutoplayTimer);
      _this12.addEventListener('mouseleave', _this12.autoplayGridy);

      // Pause for touch devices
      _this12.addEventListener('touchenter', _this12.clearAutoplayTimer);
      _this12.addEventListener('touchleave', _this12.autoplayGridy);
    }

    // THUMBNAILS INIT
    if (_this12.config.is_thumbnails_slider) {
      _this12.config.active_slide_offset = 2, _this12.config.thumbnails_for = document.getElementById(_this12.dataset.thumbnailsFor);
      _this12.thumbnail = _this12.querySelectorAll('[data-thumbnail-btn]');
      _this12.thumbnail.forEach(function (thumbnail) {
        thumbnail.addEventListener('click', _this12.onThumbnailClick.bind(_assertThisInitialized(_this12)));
      });
    }

    // CURRENT SLIDE INDICATORS INIT
    if (_this12.config.indicator) {
      _this12.indicator_dots = _this12.querySelectorAll('[data-indicator-dot]');
      _this12.indicator_current = _this12.querySelector('[data-indicator-current]');
    }

    // SCROLL LISTENER (for setting active slide after normal scroll)
    if (!_this12.config.is_thumbnails_slider) {
      var scrollTimeout;
      _this12.track.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(this.afterScrollStops.bind(this), 200);
      }.bind(_assertThisInitialized(_this12)));
    }
    return _this12;
  }
  _createClass(GridySlider, [{
    key: "afterScrollStops",
    value: function afterScrollStops() {
      var slideInView = this.firstSlideInView();
      this.config.current_slide = slideInView;
      this.setActiveSlide(this.slides[slideInView + this.config.active_slide_offset]);

      // SYNC BACK TO THUMBNAILS SLIDER
      if (this.config.thumbnail_slider) {
        this.config.thumbnail_slider.scrollToSlide(slideInView);
      }
    }
  }, {
    key: "autoplayGridy",
    value: function autoplayGridy() {
      this.config.timer = setInterval(this.scrollByIPR.bind(this), this.config.autoplay_delay, 'next');
    }
  }, {
    key: "clearAutoplayTimer",
    value: function clearAutoplayTimer() {
      clearInterval(this.config.timer);
      this.config.timer = null;
    }
  }, {
    key: "onThumbnailClick",
    value: function onThumbnailClick(event) {
      event.preventDefault();
      this.config.current_slide = Array.from(event.currentTarget.parentNode.children).indexOf(event.currentTarget);
      this.config.thumbnails_for.scrollToSlideByID(event.currentTarget.dataset.itemId);
      this.scrollToSlide(this.config.current_slide);
    }
  }, {
    key: "onArrowClick",
    value: function onArrowClick(event) {
      this.scrollByIPR(event.currentTarget.dataset.direction);
    }
  }, {
    key: "scrollByIPR",
    value: function scrollByIPR(direction) {
      var slideMultiplier = this.getCurrentSlideMultiplier(),
        slideInView = this.firstSlideInView(),
        newCurrentSlide = slideInView;
      if (direction === 'next') {
        newCurrentSlide = newCurrentSlide + slideMultiplier;
      } else if (direction === 'prev') {
        newCurrentSlide = newCurrentSlide - slideMultiplier;
      }
      if (newCurrentSlide + 1 > this.config.slide_count || slideInView > 0 && newCurrentSlide < 0) {
        newCurrentSlide = 0;
      } else if (newCurrentSlide < 0) {
        newCurrentSlide = this.config.slide_count - slideMultiplier;
      }
      this.scrollToSlide(newCurrentSlide);
    }
  }, {
    key: "scrollToSlide",
    value: function scrollToSlide(newPosition) {
      // Needs to use scrollTo() instead of scrollIntoView()
      // since the later affects window scroll and thus cannot
      // be used with autoplay sliders.

      if (isNaN(newPosition)) {
        return;
      }

      // Can show different active slide compared to scrollTo slide for example in thumbnails slider
      var slidePosWithOffset = newPosition - this.config.active_slide_offset,
        newScrollToSlidePos = slidePosWithOffset > 0 ? slidePosWithOffset : 0;
      var slideInNewScrollToPos = this.slides[newScrollToSlidePos];
      this.track.scrollTo({
        left: slideInNewScrollToPos.offsetLeft,
        top: slideInNewScrollToPos.offsetTop,
        behavior: "smooth"
      });
      this.slides.forEach(function (item) {
        item.classList.remove('active');
      });
      this.slides[newPosition].classList.add('active');
      if (document.querySelector(".product-media-slider")) {
        var getIndex = this.slides[newPosition].getAttribute("data-index");
        if (typeof getIndex != "undefined" && getIndex != null && getIndex != "") {
          document.querySelector(".product-media-slider .custom-product-slider-counter").innerText = "";
          document.querySelector(".product-media-slider .custom-product-slider-counter").innerText = getIndex;
        }
      }
    }
  }, {
    key: "scrollToSlideByID",
    value: function scrollToSlideByID(slideID) {
      // Second scrollTo method used with slideID
      // Used through thumbnails and variant change events

      var theSlide = document.getElementById(slideID),
        newPosition = Array.from(theSlide.parentNode.children).indexOf(theSlide);
      this.scrollToSlide(newPosition);
    }
  }, {
    key: "setActiveSlide",
    value: function setActiveSlide(slide) {
      this.slides.forEach(function (item) {
        item.classList.remove('active');
      });
      slide.classList.add('active');
      if (document.querySelector(".product-media-slider")) {
        var getIndex = slide.getAttribute("data-index");
        if (typeof getIndex != "undefined" && getIndex != null && getIndex != "") {
          document.querySelector(".product-media-slider .custom-product-slider-counter").innerText = "";
          document.querySelector(".product-media-slider .custom-product-slider-counter").innerText = getIndex;
        }
      }
      if (this.config.indicator) {
        this.indicator_current.textContent = this.config.current_slide + 1;
        this.indicator_dots.forEach(function (dot) {
          dot.classList.remove('active');
        });
        this.indicator_dots[this.config.current_slide].classList.add('active');
      }
    }
  }, {
    key: "getCurrentSlideMultiplier",
    value: function getCurrentSlideMultiplier() {
      var currentSlideMultiplier = this.config.ipr_mobile;
      if (woolman_window_size >= this.config.breakpoint_desktop) {
        currentSlideMultiplier = this.config.ipr_desktop;
      } else if (woolman_window_size >= this.config.breakpoint_tablet) {
        currentSlideMultiplier = this.config.ipr_tablet;
      }
      return currentSlideMultiplier;
    }

    // Utility, returns the position of the first slide in view (1..n)
  }, {
    key: "firstSlideInView",
    value: function firstSlideInView() {
      var loopIndex = 0;
      var _iterator = _createForOfIteratorHelper(this.slides),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var slide = _step.value;
          if (this.isSlideInView(slide)) {
            return loopIndex;
          }
          ++loopIndex;
        }

        // If visibility check fails return the last known current_slide
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return this.config.current_slide;
    }

    // Helper, element visibility check
  }, {
    key: "isSlideInView",
    value: function isSlideInView(slide) {
      var containerBounds = this.track.getBoundingClientRect();
      var slideBounds = slide.getBoundingClientRect();
      var isSlideVisible = Math.round(slideBounds.top) >= Math.round(containerBounds.top) && Math.round(slideBounds.bottom) <= Math.round(containerBounds.bottom) && Math.round(slideBounds.left) >= Math.round(containerBounds.left) && Math.round(slideBounds.right) <= Math.round(containerBounds.right);
      return isSlideVisible;
    }
  }]);
  return GridySlider;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('gridy-slider', GridySlider);

// QuantityInput for + and - button functionality
// Used in: cart items, upsell items
var QuantityInput = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(QuantityInput, _HTMLElement4);
  var _super4 = _createSuper(QuantityInput);
  function QuantityInput() {
    var _this13;
    _classCallCheck(this, QuantityInput);
    _this13 = _super4.call(this);
    _this13.input = _this13.querySelector('input');
    _this13.changeEvent = new Event('change', {
      bubbles: true
    });
    _this13.querySelectorAll('button').forEach(function (button) {
      return button.addEventListener('click', _this13.onButtonClick.bind(_assertThisInitialized(_this13)));
    });
    return _this13;
  }
  _createClass(QuantityInput, [{
    key: "onButtonClick",
    value: function onButtonClick(event) {
      event.preventDefault();
      var previousValue = this.input.value;
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
  }]);
  return QuantityInput;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('quantity-input', QuantityInput);